<template>
  <modal
    name="share-link"
    :width="560"
    height="auto"
    :adaptive="true"
    classes="share-link-modal"
    @closed="copiado = false"
  >
    <div class="share-link-modal__head">
      <span class="share-link-modal__title">{{ titulo }}</span>
      <button
        class="share-link-modal__close"
        type="button"
        :aria-label="$func.parseIso('close')"
        @click="$modal.hide('share-link')"
      >
        <i class="fa-regular fa-close"></i>
      </button>
    </div>
    <div class="share-link-modal__body">
      <div class="share-link-modal__summary" v-if="resumen.length">
        <span
          v-for="(linea, idx) in resumen"
          :key="idx"
          :class="{ 'share-link-modal__summary-main': idx === 0 }"
          >{{ linea }}</span
        >
      </div>
      <label class="share-link-modal__label" for="share-link-input">Link</label>
      <div class="share-link-modal__row">
        <input
          id="share-link-input"
          ref="input"
          class="share-link-modal__input"
          type="text"
          readonly
          :value="link"
          @focus="$event.target.select()"
        />
        <button class="share-link-modal__copy" type="button" @click="copiar">
          {{ $func.parseIso("copyLink") }}
        </button>
      </div>
      <div class="share-link-modal__ok" v-if="copiado" role="status">
        <i class="fa-regular fa-check"></i>
        {{ $func.parseIso("linkCopied") }}
      </div>
      <p class="share-link-modal__note">{{ $func.parseIso("shareNote") }}</p>
    </div>
  </modal>
</template>

<script>
/**
 * Ventana para copiar un link compartido (búsqueda, resort o semana).
 * Se abre con `this.$bus.emit("open-share-link", { titulo, resumen, link })`.
 */
export default {
  data() {
    return {
      titulo: "",
      resumen: [],
      link: "",
      copiado: false,
    };
  },
  created() {
    this._onOpen = ({ titulo, resumen, link }) => {
      this.titulo = titulo;
      this.resumen = (resumen || []).filter(Boolean);
      this.link = link;
      this.copiado = false;
      this.$modal.show("share-link");
    };
    this.$bus.on("open-share-link", this._onOpen);
  },
  beforeDestroy() {
    this.$bus.off("open-share-link", this._onOpen);
  },
  methods: {
    async copiar() {
      try {
        await navigator.clipboard.writeText(this.link);
        this.copiado = true;
      } catch (error) {
        // Navegadores sin portapapeles (http o versiones viejas): copiar desde el campo
        const input = this.$refs.input;
        input.focus();
        input.select();
        this.copiado = document.execCommand("copy");
      }
    },
  },
};
</script>

<style>
.share-link-modal {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}
.share-link-modal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #eef2f6;
}
.share-link-modal__title {
  font-weight: 700;
  font-size: 16px;
  color: #00527c;
}
.share-link-modal__close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #6b7280;
  width: 36px;
  height: 36px;
}
.share-link-modal__close:hover {
  color: #1a1a2e;
}
.share-link-modal__body {
  padding: 18px 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.share-link-modal__summary {
  background: #f7f8fa;
  border-radius: 8px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 13px;
  color: #4b5563;
}
.share-link-modal__summary-main {
  font-weight: 700;
  color: #1a1a2e;
}
.share-link-modal__label {
  font-size: 12px;
  font-weight: 700;
  color: #4b5563;
  margin: 0;
}
.share-link-modal__row {
  display: flex;
  gap: 8px;
}
.share-link-modal__input {
  flex: 1;
  min-width: 0;
  height: 40px;
  border: 1.5px solid #dde3ea;
  border-radius: 6px;
  padding: 0 10px;
  font-size: 13px;
  color: #1a1a2e;
  background: #fff;
}
.share-link-modal__copy {
  height: 40px;
  padding: 0 16px;
  border: none;
  border-radius: 6px;
  background: #0472aa;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}
.share-link-modal__copy:hover {
  background: #00527c;
}
.share-link-modal__ok {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #e8f5e9;
  color: #1b5e20;
  border-radius: 6px;
  padding: 9px 12px;
  font-size: 13px;
  font-weight: 700;
}
.share-link-modal__note {
  margin: 0;
  font-size: 12px;
  color: #6b7280;
}
@media (max-width: 480px) {
  .share-link-modal__row {
    flex-direction: column;
  }
  .share-link-modal__input {
    flex: none;
  }
}
</style>
